import {FC} from 'react';

const HomeBase:FC< {redirect_uri: string}>=(props)=>{
    const redirectToHomeBase = () => {
        window.location.href = props.redirect_uri;
      };
    return (<button className='Home-return_homebase' onClick={redirectToHomeBase}>ほめべーすに戻る</button>)
}

export default HomeBase;